var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90481 13.9248C1.9763 13.6001 1.94902 13.2614 1.82647 12.9523C0.973715 11.1829 0.773271 9.16928 1.26051 7.26656C1.74774 5.36385 2.89135 3.69435 4.48955 2.55264C6.08776 1.41093 8.03785 0.870364 9.99577 1.02633C11.9537 1.18229 13.7936 2.02475 15.1909 3.40508C16.5882 4.78541 17.4531 6.61489 17.633 8.57075C17.8128 10.5266 17.2961 12.4831 16.174 14.0952C15.0519 15.7072 13.3965 16.8711 11.4999 17.3815C9.60323 17.892 7.58725 17.7161 5.80762 16.8851C5.51554 16.7742 5.19817 16.7476 4.89172 16.8084L2.04733 17.6401C1.91012 17.6765 1.76588 17.6773 1.62829 17.6423C1.49071 17.6074 1.36433 17.5378 1.26115 17.4403C1.15797 17.3428 1.08141 17.2206 1.03873 17.0852C0.99604 16.9498 0.988645 16.8058 1.01724 16.6667L1.90481 13.9248Z",
    stroke: "#62828C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.4595f24960c0cea841ef71e33782ee43.svg";
export { ForwardRef as ReactComponent };